export const OPTOUT_KEY = "ccp_privacy_optout";

export function isGpcEnabled(): boolean {
  if (typeof navigator === "undefined") return false;
  try {
    return (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true;
  } catch {
    return false;
  }
}

export function hasManualOptOut(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(OPTOUT_KEY) === "1";
  } catch {
    return false;
  }
}

export function isTrackingSuppressed(): boolean {
  return isGpcEnabled() || hasManualOptOut();
}

export function setManualOptOut(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(OPTOUT_KEY, "1");
  } catch {
    // ignore
  }
}

export function clearManualOptOut(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(OPTOUT_KEY);
  } catch {
    // ignore
  }
}

export function getOptOutStatus(): { optedOut: boolean; viaGpc: boolean; viaManual: boolean } {
  const viaGpc = isGpcEnabled();
  const viaManual = hasManualOptOut();
  return { optedOut: viaGpc || viaManual, viaGpc, viaManual };
}
